<template>
  <div class="border-b border-default bg-primary/10 px-4 py-2 text-center text-xs text-muted">
    非官方 Nuxt 中文镜像。内容自动同步并翻译自
    <a
      class="font-medium text-primary hover:underline"
      href="https://nuxt.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      nuxt.com
    </a>
    ，如有歧义请以英文原文为准。
  </div>
</template>
